export default __webpack_public_path__ + "static/reward-individual-0715a9f219c981d5b9bb2f23ab46dd47.png";